import styled from "styled-components";

export const NewBadge = styled.div`
  position: absolute;
  height: 30px;
  background-color: #79D9D9;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 700;
  text-transform: uppercase;
  font-size: 0.8em;
  width: 105px;
  transform: rotate(-35deg);
  right: -32px;
  bottom: 3px;
  box-shadow: 0 0 10px #d2d2d2;
`;

export const NewBadgeWrapper = styled.div`
  position: absolute;
  height: 80px;
  width: 80px;
  bottom: 0;
  right: 0;
  overflow: hidden;
`;
